package kz.dentalcrm.app.screens.service_categories.add.mvi

import androidx.compose.runtime.Immutable
import kz.dentalcrm.app.core.base.ViewState

@Immutable
data class AddServiceCategoryViewState(
    val screenState: ScreenState = ScreenState.Idle
) : ViewState {
    sealed interface ScreenState {
        data object Idle : ScreenState
        data object Adding : ScreenState
        data object Added : ScreenState
        data class Error(val error: String) : ScreenState
    }
}
